(function () {
  const cfg = window.dclRamUpgrade;
  if (!cfg) return;

  const groups = document.querySelectorAll('.ram-upgrade-options');
  if (!groups.length) return;

  const priceDisplay = document.getElementById('product-price-display');
  const stickyPriceDisplay = document.getElementById('sticky-price-display');
  const priceNote = document.getElementById('price-upgrade-note');
  const qtyInput = document.getElementById('qty-input');
  const basePriceCents = cfg.basePriceCents || 0;

  function getQty() {
    const val = qtyInput ? parseInt(qtyInput.value, 10) : 1;
    return (isNaN(val) || val < 1) ? 1 : val;
  }

  function formatPrice(cents) {
    return (cents / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }

  function getSelectedUpgrades() {
    const selected = [];
    groups.forEach(group => {
      const checked = group.querySelector('input[type="radio"]:checked');
      if (checked && checked.value) {
        selected.push({
          id: parseInt(checked.value, 10),
          title: checked.dataset.title || '',
          priceCents: parseInt(checked.closest('.ram-upgrade-option').dataset.priceCents || '0', 10)
        });
      }
    });
    return selected;
  }

  function updatePriceDisplay() {
    const selected = getSelectedUpgrades();
    const upgradeTotalPerUnit = selected.reduce((sum, u) => sum + u.priceCents, 0);
    const qty = getQty();
    const total = (basePriceCents + upgradeTotalPerUnit) * qty;
    const formatted = formatPrice(total);

    if (priceDisplay) priceDisplay.textContent = formatted;
    if (stickyPriceDisplay) stickyPriceDisplay.textContent = formatted;

    if (priceNote) {
      if (upgradeTotalPerUnit > 0) {
        priceNote.textContent = 'Preis mit gewählter Aufrüstoption' + (qty > 1 ? ' × ' + qty + ' Stück' : '');
        priceNote.style.display = 'block';
      } else {
        priceNote.textContent = '';
        priceNote.style.display = 'none';
      }
    }
  }

  groups.forEach(group => {
    group.querySelectorAll('input[type="radio"]').forEach(input => {
      input.addEventListener('change', e => {
        group.querySelectorAll('.ram-upgrade-option').forEach(el => el.classList.remove('selected'));
        e.target.closest('.ram-upgrade-option').classList.add('selected');
        updatePriceDisplay();
      });
    });
  });

  if (qtyInput) {
    qtyInput.addEventListener('input', updatePriceDisplay);
    qtyInput.addEventListener('change', updatePriceDisplay);
    document.querySelector('.qty-minus')?.addEventListener('click', () => setTimeout(updatePriceDisplay, 0));
    document.querySelector('.qty-plus')?.addEventListener('click', () => setTimeout(updatePriceDisplay, 0));
  }

  document.addEventListener('submit', function (e) {
    const form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;

    const selected = getSelectedUpgrades();
    if (selected.length === 0) return;

    e.preventDefault();
    e.stopPropagation();

    const qty = getQty();
    const konfigText = selected.map(u => u.title).filter(Boolean).join(', ');

    const items = [
      {
        id: cfg.pcVariantId,
        quantity: qty,
        properties: { 'Konfiguration': 'inkl. Upgrades: ' + konfigText }
      },
      ...selected.map(u => ({
        id: u.id,
        quantity: qty,
        properties: { 'Upgrade für': document.title }
      }))
    ];

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items })
    })
      .then(r => r.json())
      .then(() => { window.location.href = '/cart'; })
      .catch(err => console.error('Fehler beim Hinzufügen zum Warenkorb:', err));
  }, true);
})();